import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {cloneDeep} from "lodash";
import {Observable} from "rxjs";

export interface DialogInputListItemModel {
  metadata;
  title: string;
  listItem;
}

@Component({
  templateUrl: "./modify-list-item.template.pug",
})
export class ModifyListItemDialogComponent
  extends DialogComponent<DialogInputListItemModel, any>
  implements DialogInputListItemModel {
  public error: Error;
  public listItem;
  public metadata;
  public title;

  static showDialog(
    dialogService: DialogService,
    item: DialogInputListItemModel,
  ): Observable<any> {
    return dialogService.addDialog(
      ModifyListItemDialogComponent,
      cloneDeep(item), // Needed otherwise modifications change the base object even if we cancel
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }

  cancel(): void {
    this.result = null;
    this.close();
  }

  save(): void {
    this.result = this.listItem;
    this.close();
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }
}
